// Utility to convert formData to API body for retractConsent
import { clearPhone } from '../utils/string';

export function mapRevokeFormToApiBody(formData, recaptchaValue) {
    return {
        apiClient: 'ONLINE',
        lastName: formData.lastName.value,
        firstName: formData.firstName.value,
        middleName: formData.middleName.value,
        birthDate: formData.birthDate.value,
        sex: formData.sex.value,
        phone: clearPhone(formData.phone.value),
        recaptchaValue,
    };
}
